import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Modal, Stack } from '@mui/material';
import { Visibility as VisibilityIcon, Close as CloseIcon } from '@mui/icons-material';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';
import { useContext, useEffect } from 'react';
import { ToolContext } from '../../../../core/context/ToolContext';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import { useLocation, useHistory } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import { EmptyList } from '../../../../core/global/realproperty/Index';
import dayjs from "dayjs";

export const Inquiries = () => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { inquiries } = realproperty_state;
    const nav = useHistory();
    const view = new URLSearchParams(useLocation().search).get("view");
    // for infinite scroll states (other way of infinite scroll implementaion)
    const __init = async (val) => {
        if (val === 0) {
            inquiries.set((p) => ({ ...p, inquiriesLoader: true,  inquiresInftScroll: true })) 
        }
        inquiries.set((p) => ({ ...p, inquiresIsLoading: true }))
        let web_id = inquiries.data.inquiriesWebId;
        if (!inquiries.data.inquiriesWebId ) {
            const res_temp = await rqx.get(`<<tool>>/${env()}/realPropertyWebsite/read`, { company_id: tool_state.__SESSION.data.uaccess[0].company_id});
            web_id = res_temp[0].id
            inquiries.set((p) => ({ ...p, inquiriesWebId: res_temp[0].id }))
        }
        const res_list = await rqx.get(`<<tool>>/${env()}/propertyListing/read_inquiries`, {
            lastId: val,
            limit: 15,
            web_id: web_id,
        });

        if (res_list) {
            const last_id = res_list.length > 0 ? res_list[res_list.length - 1].id : val;
            inquiries.set((p) => ({ ...p, inquiriesLastId: last_id })) 
            if (val === 0 || val === undefined || val === "") {
                inquiries.set((p) => ({ ...p, inquiriesList: res_list })) 
            } else {
                inquiries.set((p) => ({ ...p, inquiriesList: [...p.inquiriesList, ...res_list] })) 
            }
            if (res_list.length < 15) {
                inquiries.set((p) => ({ ...p, inquiresInftScroll: false, inquiriesHasMore: false })) 
            }
        }
        inquiries.set((p) => ({ ...p, inquiresIsLoading: false, inquiriesLoader: false })) 
    };

    const loadMoreData = async () => {
        if (inquiries.data.inquiriesCooldown || inquiries.data.inquiresIsLoading || !inquiries.data.inquiriesHasMore) return;
        inquiries.set((p) => ({ ...p, inquiriesCooldown: true })) 
        await __init(inquiries.data.inquiriesLastId);
        setTimeout(() => inquiries.set((p) => ({ ...p, inquiriesCooldown: false })) , 500);
    };

    useEffect(() => {
        inquiries.set((p) => ({
            ...p,
            inquiriesList: [],
            inquiriesLoader: false,
            inquiriesModal: false,
            inquiriesWebId: null,
            inquiresInftScroll: true,
            inquiresIsLoading: false,
            inquiriesCooldown: false,
            inquiriesHasMore: true,
            inquiriesLastId: 0,
        }))
        __init(0);
        // eslint-disable-next-line
    }, []);

    const viewInquiries = (id) => {
        nav.push(`/realproperty/inquiries?view=${window.btoa(id)}`)
        inquiries.set((p) => ({...p, inquiriesModal: true}))
    }

    const closeModal = () => {
        nav.push(`/realproperty/inquiries`)
        inquiries.set((p) => ({...p, inquiriesModal: false}))
    }

    return (
        <Box mt="1rem">
            { inquiries.data.inquiriesLoader ? 
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box> 
            :
                inquiries.data.inquiriesList.length === 0 ? 
                    <EmptyList text="No inquiries have been received yet."/>
                :
                    <>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }}>
                                <TableHead sx={(theme) => ({ bgcolor: theme.palette.primary.main })}>
                                    <TableRow>
                                        <TableCell align="center" sx={{ color: "white", width: "4rem", }}>No.</TableCell>
                                        <TableCell align="left" sx={{ color: "white", width: "8rem" }}>Date Inquired</TableCell>
                                        <TableCell align="left" sx={{ color: "white" }}>Name</TableCell>
                                        <TableCell align="left" sx={{ color: "white", width: "10rem" }}>Mobile Number</TableCell>
                                        <TableCell align="left" sx={{ color: "white" }}>Email</TableCell>
                                        <TableCell align="center" sx={{ color: "white", width: "5rem" }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {inquiries.data.inquiriesList?.map((v, k) => (
                                    <TableRow key={k}>
                                        <TableCell component="th" scope="row" align="center">
                                            {inquiries.data.inquiriesList.length - k}
                                        </TableCell>
                                        <TableCell align="left">{dayjs(v.created_at).format("MM/DD/YYYY")}</TableCell>
                                        <TableCell align="left">{v.full_name}</TableCell>
                                        <TableCell align="left">{v.mobile_number}</TableCell>
                                        <TableCell align="left">{v.email}</TableCell>
                                        <TableCell align="center"><VisibilityIcon onClick={() => viewInquiries(v.id)} fontSize="small" sx={{ cursor: "pointer", transition: "0.25s" ,':hover': { color: "grey" } }}/></TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Modal open={inquiries.data.inquiriesModal} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Box width="400px" bgcolor="#fff" borderRadius="8px" p="1.5rem">
                                <Stack flexDirection="row" justifyContent="space-between">
                                    <Typography fontWeight="600" fontSize={20}>Real Property Inquiry</Typography>
                                    <CloseIcon onClick={() => closeModal()} sx={{ cursor: "pointer", transition: "0.25s" , "&:hover": { backgroundColor: "#f0f2f4" } }}/>
                                </Stack>
                                { inquiries.data.inquiriesList?.filter(v => v.id === Number(window.atob(view))).map(v => (
                                    <Stack my="1.5rem" gap="1rem" px="0.5rem" key={v.id}>
                                        <Typography><b>Date Applied:</b> {dayjs(v.created_at).format("MM/DD/YYYY")}</Typography>
                                        <Typography><b>Name:</b> {v.full_name}</Typography>
                                        <Typography><b>Mobile Number:</b> {v.mobile_number}</Typography>
                                        <Typography><b>Email:</b> {v.email}</Typography>
                                        <Typography><b>Message:</b> {v.message}!</Typography>      
                                    </Stack>
                                ))}                          
                            </Box>
                        </Modal>
                        {inquiries.data.inquiresInftScroll && inquiries.data.inquiriesHasMore && (
                            <Box sx={{ mt: "2rem" }}>
                                <Waypoint onEnter={loadMoreData}>
                                    <Box display="flex" justifyContent="center" my={2}>
                                        <SnakeLoader
                                            bg="#11783C"
                                            size="12px"
                                            distance="8px"
                                        />
                                    </Box>
                                </Waypoint>
                            </Box>
                        )}
                    </>
            }
        </Box>
    )
}
